<template>
  <div v-if="hasAssets" class="wrapper home">
    <div class="d-flex w-100">
      <div class="left">
        <!-- Steven changes starts - DMA co-brand: "with {Realtor}" next to the logo -->
        <div class="logo-row">
        <!-- Steven changes ends -->
        <div class="logo">
          <a>
            <img
              v-if="getAssets && getAssets.horizontalTeamLogo"
              :src="getAssets.horizontalTeamLogo"
              alt="Team-Logo"
            />
          </a>
        </div>
        <!-- Steven changes starts - DMA co-brand: "with {Realtor}" next to the logo -->
          <div
            v-if="hasCoBrand"
            class="cobrand-with"
            :class="{ 'cobrand-with--no-logo': !(getAssets && getAssets.horizontalTeamLogo) }"
          >
            {{ translatedData?.withText }} <strong>{{ shownCoBrand.name }}</strong>
          </div>
        </div>
        <!-- Steven changes ends -->
        <div class="main-heading">
          <h2>{{ translatedData?.homeTitle }}</h2>
          <a role="button" @click="typeSelection('Buying')" class="btn btn-red">
            <span>{{ translatedData?.continueButtonBuyingText }}</span>
          </a>
        </div>
        <!-- Steven changes starts - DMA co-brand: LO + realtor at the bottom-left (LO only when the realtor has no headshot) -->
        <div v-if="hasCoBrand" class="cobrand-footer">
          <div class="cobrand-avatars">
            <img
              :src="shownCoBrand.loHeadshot || defaultAvatar"
              :alt="shownCoBrand.loName"
            />
            <img
              v-if="shownCoBrand.headshot"
              :src="shownCoBrand.headshot"
              :alt="shownCoBrand.name"
            />
          </div>
          <div class="cobrand-names">
            <p v-if="shownCoBrand.headshot" class="cobrand-names__title">
              {{ shownCoBrand.loName }} &amp; {{ shownCoBrand.name }}
            </p>
            <p v-else class="cobrand-names__title">{{ shownCoBrand.loName }}</p>
            <p class="cobrand-names__sub">
              {{
                shownCoBrand.headshot
                  ? translatedData?.loAndRealtorText
                  : translatedData?.loOnlyText
              }}
            </p>
          </div>
        </div>
        <!-- Steven changes ends -->
      </div>
      <div class="right">
        <div class="nav-link" v-show="!getCreateAppFlag && !getCloneAppFlag">
          <router-link to="/sign-in" class="btn btn-white"
            ><span>{{ translatedData?.signInButtonText }}</span></router-link
          >
        </div>
        <div class="main-heading">
          <h2>{{ translatedData?.refinanceTitle }}</h2>
          <a
            role="button"
            @click="typeSelection('Refinance')"
            class="btn btn-white"
          >
            <span>{{ translatedData?.continueButtonRefinanceText }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="legal-links">
      <router-link to="/terms-of-use">Terms of Use</router-link>
      <span class="legal-links__separator">|</span>
      <router-link to="/privacy-policy">Privacy Policy</router-link>
    </div>
  </div>
</template>

<script>
const homePageJson = {
  homeTitle: "I’m buying a home",
  continueButtonBuyingText: "Continue",
  refinanceTitle: "I’m refinancing my home",
  continueButtonRefinanceText: "Continue",
  signInButtonText: "Sign-In",
  // Steven changes starts - DMA co-brand labels
  withText: "with",
  loAndRealtorText: "Your loan officer and Realtor®",
  loOnlyText: "Your loan officer",
  // Steven changes ends
};
import { mapActions, mapGetters } from "vuex";
import commonFunctions from "./../mixins/commonfunctions";
import CoPilotFeature from "./../mixins/salesforce-co-pilot"; //Logic for Salesforce Co-Pilot feature is in this mixin
import { translationMixin } from "../mixins/translationMixin";
// Steven changes starts - DMA co-brand: fallback photo when the LO has no headshot
import defaultAvatar from "../assets/images/user-avatar.png";
// Steven changes ends
export default {
  name: "Index",
  mixins: [commonFunctions, CoPilotFeature, translationMixin],
  data() {
    return {
      data: homePageJson,
      isDataFetched: false,
      // Steven changes starts - DMA co-brand
      defaultAvatar,
      // Steven changes ends
    };
  },
  computed: {
    ...mapGetters([
      "getOrgId",
      "getProspectId",
      "getHomePageTailUrl",
      "getAppFlow",
      "getUserId",
      "getAssets",
      "getQuestions",
      "getCreateAppFlag",
      "getCloneAppId",
      "getCloneAppFlag",
      "getApplications",
      "getActiveQuestion",
      "getIsCoPilot",
      "getSetupPassword",
      "getActivePage",
      "getCoPilotSession",
      // Steven changes starts - DMA co-brand
      "getCoBrand",
      "getUser",
      // Steven changes ends
    ]),

    // Steven changes starts - DMA co-brand: only when Salesforce returned a realtor
    hasCoBrand() {
      return !!(this.shownCoBrand && this.shownCoBrand.name);
    },
    // Signed in: the application's realtor and LO win (an application without a realtor shows none).
    // Not signed in: the realtor from the link.
    shownCoBrand() {
      const user = this.getUser;
      if (this.getIsAuthenticated && user && Object.keys(user).length) {
        return {
          name: user.realtorName || "",
          headshot: user.realtorHeadshot || "",
          loName: user.name || "",
          loHeadshot: user.profilePhotoURL || "",
        };
      }
      return this.getCoBrand || {};
    },
    // Steven changes ends

    hasAssets() {
      return this.getAssets && Object.keys(this.getAssets).length;
    },

    isVanityURL() {
      const urlParam = this.getHomePageTailUrl;
      if (!urlParam) return false;

      const legacyPattern = /^[^/]+\/[a-zA-Z0-9]{15,18}&[a-zA-Z0-9]{15,18}$/;
      return !legacyPattern.test(urlParam);
    },
  },
  watch: {
    isDataFetched: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(async () => {
            await this.getAppAssets();
            // Steven changes starts - DMA co-brand: realtor from #cobrand= (or from the link's own Account id)
            // Not awaited: co-brand is optional and must never slow down or block the homescreen.
            this.getCoBrandAssets();
            // Steven changes ends

            if (this.getOrgId && this.getProspectId) {
              if (
                this.getIsCoPilot &&
                (this.getCloneAppFlag || this.getCreateAppFlag)
              ) {
                this.fetchLoaderStatus(false);
              }

              if (!this.getIsCoPilot) {
                this.fetchLoaderStatus(false);
                if (!this.getCloneAppFlag && !this.getCreateAppFlag)
                  await this.checkPasswordStatus();
              }
            }
          });
        }
      },
    },
  },
  async mounted() {
    this.isDataFetched = await this.fetchDataFromUrl();
  },
  methods: {
    ...mapActions([
      "fetchOrgId",
      "fetchProspectId",
      "fetchCompanyName",
      "fetchHomePageTailUrl",
      "fetchUserId",
      "fetchUser",
      "fetchActiveQuestion",
      "fetchActiveSection",
      "fetchAppFlow",
      "fetchQuestions",
      "fetchSubQuestions",
      "fetchSections",
      "fetchLoaderStatus",
      "fetchCreateAppFlag",
      "fetchCloneAppId",
      "fetchCloneAppFlag",
      "updateApplications",
      "fetchForgotPassDetails",
      "fetchActivePage",
      "updateQueObjectWithAnswer",
      // Steven changes starts - DMA co-brand
      "fetchCoBrandId",
      "fetchCoBrand",
      // Steven changes ends
    ]),

    async fetchDataFromUrl() {
      try {
        const urlParam = this.$route.params.unique_key;
        // Steven changes starts - DMA co-brand: remember the previous link before it is overwritten
        const previousTailUrl = this.getHomePageTailUrl;
        // Steven changes ends
        this.fetchHomePageTailUrl(urlParam);

        // Steven changes starts - DMA co-brand: realtor Account id from #cobrand= (legacy and vanity links)
        // A hash, not a query string: any query string makes this app start a Salesforce Co-Pilot
        // sign-in (salesforce-co-pilot.js), and older builds ignore the hash entirely.
        // In-app "back to home" navigation drops the hash, so the same link keeps its realtor;
        // a different link without #cobrand= clears it so another link's realtor never carries over.
        const coBrandMatch = /(?:^#|&)cobrand=([a-zA-Z0-9]{15,18})(?:&|$)/.exec(
          this.$route.hash || ""
        );
        const nextCoBrandId = coBrandMatch
          ? coBrandMatch[1]
          : previousTailUrl === urlParam
          ? this.getCoBrandId
          : "";
        if (nextCoBrandId !== this.getCoBrandId) {
          this.fetchCoBrandId(nextCoBrandId);
          this.fetchCoBrand({});
        }
        // Steven changes ends

        const isVanityRoute = this.$route.meta?.isVanity === true;
        console.log("isVanityRoute:", isVanityRoute);

        return isVanityRoute
          ? await this.useVanityURL(urlParam)
          : await this.useLegacyURL(urlParam);
      } catch (error) {
        console.error("Error fetching data from URL:", error);
        return false;
      }
    },

    async useVanityURL(officerName) {
      try {
        const domainUrl = this.extractDomainAfterFirstSubdomain();

        if (!officerName) throw new Error("No Loan Officer found in URL");
        if (!domainUrl) throw new Error("Could not extract domain");

        const response = await this.$http.get(
          `api/loan-officers/domain-search?officerName=${encodeURIComponent(
            officerName
          )}&url=${encodeURIComponent(domainUrl)}`
        );

        const data = response?.data?.data;

        if (data.orgId && data.loUserId) {
          this.fetchOrgId(data.orgId);
          this.fetchProspectId(data.loUserId);
          this.fetchCompanyName(data.orgName);
          return true;
        } else {
          throw new Error("Invalid API response");
        }
      } catch (error) {
        console.error("Error handling vanity URL:", error);
        return false;
      }
    },

    async useLegacyURL(urlParam) {
      try {
        const [companyName, idsPart] = urlParam.split("/");
        const [loUserId, orgId] = idsPart.split("&");

        this.fetchOrgId(orgId);
        this.fetchProspectId(loUserId);
        this.fetchCompanyName(companyName);
        return true;
      } catch (error) {
        console.error("Error handling legacy URL:", error);
        return false;
      }
    },

    extractDomainAfterFirstSubdomain() {
      try {
        const hostname = window.location.hostname.replace(/^www\./, "");

        if (hostname === "localhost") {
          return "locklearlendingteam.com";
        }

        const parts = hostname.split(".");

        if (parts.length >= 2) {
          return parts.slice(-2).join(".");
        }

        return hostname;
      } catch (error) {
        console.error("Error extracting domain:", error);
        return null;
      }
    },

    typeSelection(appflow) {
      this.fetchActivePage(true);
      if (this.getCreateAppFlag) this.createNewApp(appflow);
      if (this.getCloneAppFlag) this.cloneTheApp(appflow);

      if (!this.getCreateAppFlag && !this.getCloneAppFlag) {
        if (this.getUserId) this.proceedToQuestionnaire(appflow);
        else this.enterTheApplication(appflow);
      }
    },

    proceedToQuestionnaire(appflow) {
      if (appflow === this.getAppFlow)
        this.$router.push({ path: "/questionnaire" });

      if (appflow !== this.getAppFlow) this.enterTheApplication(appflow);
    },

    async enterTheApplication(value) {
      this.fetchLoaderStatus(true);

      let user_id = this.getUserId || null;

      await this.$http
        .get(
          "/question/GetProspectQuestions/" +
            value +
            "/" +
            user_id +
            "?orgId=" +
            this.getOrgId
        )
        .then((response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            this.fetchAppFlow(value);
            this.fetchSections(resp.sidebarSections);
            this.fetchQuestions(resp.appQuestions);
            this.fetchSubQuestions(resp.subQuestions);

            this.setActiveQueAndSection();

            this.$router.push({ path: "/questionnaire" });
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            console.log(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          this.err(error);
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },

    // Create New Application or Clone Application code starts from here
    async cloneTheApp(type) {
      this.fetchLoaderStatus(true);

      let payLoad = {
        copyApplication: true,
        flowName: type,
        orgId: this.getOrgId,
        prospectId: this.getCloneAppId,
        isCopilotSession: this.getCoPilotSession,
      };

      await this.$http
        .post("/account/createAndCopyDMAApplicationAPI", payLoad)
        .then(async (response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            this.success(resp.message);
            this.updateApplications(resp.applications);
            this.fetchCloneAppFlag(false);
            this.fetchCloneAppId("");

            await this.continueWithApp(resp.applications[0]);
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },

    async createNewApp(type) {
      this.fetchLoaderStatus(true);

      let payLoad = {
        copyApplication: false,
        flowName: type,
        orgId: this.getOrgId,
        prospectId: this.getApplications[0].prospectId,
        isCopilotSession: this.getCoPilotSession,
      };

      await this.$http
        .post("/account/createAndCopyDMAApplicationAPI", payLoad)
        .then(async (response) => {
          this.fetchLoaderStatus(true);
          let resp = response.data;

          if (resp.response === "Success") {
            this.success(resp.message);
            this.updateApplications(resp.applications);
            this.fetchCreateAppFlag(false);

            await this.continueWithApp(resp.applications[0]);
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },

    async continueWithApp(app) {
      if (app.type !== this.getAppFlow) await this.getQuestionnaire(app);

      await this.$http
        .get(
          "/account/getSingleQuestionAnswer?prospectId=" +
            app.prospectId +
            "&orgId=" +
            this.getOrgId +
            "&flowName=" +
            app.type
        )
        .then((response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            this.fetchUserId(resp.prospectId);
            this.fetchUser(resp.prospectdetails);
            this.updateQueObjectWithAnswer(resp.appQuestions);
            this.flushPendingAppLanguage(resp.prospectId);

            this.setActiveQueAndSection();

            this.$router.push("/questionnaire");
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },

    async getQuestionnaire(app) {
      this.fetchAppFlow(app.type);

      await this.$http
        .get(
          "/question/GetProspectQuestions/" +
            this.getAppFlow +
            "/" +
            app.prospectId +
            "?orgId=" +
            this.getOrgId
        )
        .then((response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            this.fetchSections(resp.sidebarSections);
            this.fetchQuestions(resp.appQuestions);
            this.fetchSubQuestions(resp.subQuestions);

            this.setActiveQueAndSection();
          }

          if (resp.response === "Error") this.err(resp.message);
        })
        .catch((error) => {
          this.err(error);
          console.log(error);
        });
    },
    // Create New Application or Clone Application code ends from here

    setActiveQueAndSection() {
      this.fetchActiveQuestion(1);

      let getSectionName = this.getQuestions.find(
        (v) => v.questionIndex === this.getActiveQuestion
      );

      this.fetchActiveSection(getSectionName.sectionName);
    },

    async checkPasswordStatus() {
      this.fetchLoaderStatus(true);

      await this.$http
        .get(
          "/account/AppDetailAPI?orgId=" +
            this.getOrgId +
            "&recordId=" +
            this.getProspectId
        )
        .then(async (response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            if (resp.assetData.appStarted && this.getSetupPassword)
              await this.setPassword(resp.assetData.userEmail);
            else this.fetchLoaderStatus(false);
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            console.log(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },

    async setPassword(email) {
      await this.$http
        .get(
          "/account/forgotPassword?emailOrPhone=" +
            email +
            "&msgOrEmail=" +
            "email" +
            "&orgId=" +
            this.getOrgId
        )
        .then((response) => {
          let resp = response.data;

          if (resp.response === "Success") {
            this.fetchForgotPassDetails(resp.prospectDetail);
            this.success(resp.message);
            this.$router.push({ path: "/reset-password" });
          }

          if (resp.response === "Error") {
            this.err(resp.message);
            this.fetchLoaderStatus(false);
          }
        })
        .catch((error) => {
          this.err(error);
          console.log(error);
          this.fetchLoaderStatus(false);
        });
    },
  },
};
</script>

<style scoped>
/* Steven changes starts - DMA co-brand */
.logo-row {
  display: flex;
  align-items: center;
}

.cobrand-with {
  padding-top: 35px;
  margin-left: 14px;
  padding-left: 14px;
  border-left: 1px solid #d9d9d9;
  font-size: 14px;
  font-family: "Lato", sans-serif;
  color: #6b6b6b;
  white-space: nowrap;
}

.cobrand-with strong {
  color: #222222;
  font-weight: 700;
}

/* no team logo: no divider to separate it from */
.cobrand-with--no-logo {
  margin-left: 0;
  padding-left: 0;
  border-left: none;
}

.cobrand-footer {
  margin-top: auto;
  padding-bottom: 56px;
  /* keep clear of the arrow artwork (25% wide, 60px from the right edge of .left) */
  padding-right: calc(25% + 70px);
  display: flex;
  align-items: center;
  gap: 10px;
}

.cobrand-avatars {
  display: flex;
  flex-shrink: 0;
}

.cobrand-avatars img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ffffff;
  background: #ffffff;
  box-shadow: 0 0 0 1px #e5e5e5;
}

.cobrand-avatars img + img {
  margin-left: -8px;
}

.cobrand-names p {
  margin: 0;
  font-family: "Lato", sans-serif;
  line-height: 1.3;
}

.cobrand-names__title {
  font-size: 14px;
  color: #222222;
}

.cobrand-names__sub {
  font-size: 12px;
  color: #6b6b6b;
}

@media only screen and (max-width: 580px) {
  /* phones: "with {Realtor}" goes under the logo so it never runs into the Sign-In button */
  .logo-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .cobrand-with {
    padding-top: 8px;
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    white-space: normal;
  }

  .cobrand-footer {
    padding-right: calc(25% + 40px);
  }
}
/* Steven changes ends */

.legal-links {
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 10;
}

.legal-links a {
  color: #ffffff;
  font-size: 13px;
  font-family: "Lato", sans-serif;
  text-decoration: none;
  opacity: 0.85;
  transition: opacity 0.2s;
}

.legal-links a:hover {
  opacity: 1;
  text-decoration: underline;
}

.legal-links__separator {
  color: #ffffff;
  font-size: 13px;
  margin: 0 8px;
  opacity: 0.6;
}
</style>